import { Button } from "common/components/ui/Button";
import {
  DialogClose,
  DialogDescription,
  DialogTitle,
} from "common/components/ui/Dialog";
import { DrawerDescription, DrawerTitle } from "common/components/ui/Drawer";
import useCustomer from "common/datahooks/useCustomer";
import { useSelectedWorkspaceContext } from "common/helpers/SelectedWorkspaceContext";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useMembersMutations from "../../datahooks/useMembersMutations";

interface RemoveMemberProps {
  memberId: string;
  email: string;
  onBack: () => void;
}

export default function RemoveMember({
  memberId,
  email,
  onBack,
}: RemoveMemberProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { name: workspaceName } = useSelectedWorkspaceContext();
  const {
    customerInfo: { email: customerEmail },
  } = useCustomer();

  const { removeMember, leaveWorkspace, isRemovingMember, isLeavingWorkspace } =
    useMembersMutations();

  const isLoading = isRemovingMember || isLeavingWorkspace;
  const isCustomerMember = customerEmail === email;

  function handleRemoveClick() {
    if (customerEmail === email) {
      leaveWorkspace({ memberId });
      return;
    }

    removeMember({ memberId });
  }

  const Title = isDesktop ? DialogTitle : DrawerTitle;
  const Description = isDesktop ? DialogDescription : DrawerDescription;

  return (
    <>
      <Title>
        {isCustomerMember
          ? "Are you sure you want to leave this workspace?"
          : "Remove from workspace?"}
      </Title>

      <Description className="mb-8">
        {isCustomerMember ? (
          "You will no longer be able to access this workspace or any data related to it"
        ) : (
          <>
            Are you sure you want to remove{" "}
            <span className="font-semibold text-black-950">
              &apos;{email}&apos;{" "}
            </span>
            from {workspaceName}
          </>
        )}
      </Description>

      <div className="flex justify-between gap-x-2.5">
        <Button
          variant="secondary-black"
          className="lg:flex-1"
          disabled={isLoading}
          onClick={onBack}
        >
          Cancel
        </Button>

        <DialogClose asChild>
          <Button
            variant="outline-danger"
            className="lg:flex-1"
            isLoading={isLoading}
            onClick={handleRemoveClick}
          >
            {isCustomerMember ? "Leave workspace" : "Remove"}
          </Button>
        </DialogClose>
      </div>
    </>
  );
}
